import { gql } from "@apollo/client";

export const VALIDATE_INVOICE = gql`
  mutation validateInvoice(
    $input: ValidateInvoiceInput!
    $clientIdentifier: String!
  ) {
    invoice {
      validateInvoice(input: $input, clientIdentifier: $clientIdentifier) {
        createdAt
        invoiceDataValidationId
        isValid
      }
    }
  }
`;
